import type { ReactNode } from "react";

export function SectionHeader({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        fontFamily: "var(--font-body)",
        fontSize: 13,
        color: "var(--fg-section-header)",
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        fontWeight: 500,
        padding: "18px 16px 8px",
      }}
    >
      {children}
    </div>
  );
}

export function ListGroup({ children }: { children: ReactNode }) {
  return (
    <div
      className="sp-list-group"
      style={{
        background: "var(--bg-section)",
        borderRadius: "var(--r-lg)",
        margin: "0 16px",
        overflow: "hidden",
      }}
    >
      {children}
    </div>
  );
}

interface ListRowProps {
  leading?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
}

export function ListRow({ leading, title, subtitle, trailing, onClick }: ListRowProps) {
  return (
    <div
      className="sp-list-row"
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 16px",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      {leading && <div style={{ flex: "none" }}>{leading}</div>}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: "var(--font-body)",
            fontSize: 17,
            fontWeight: 500,
            color: "var(--fg1)",
            lineHeight: "22px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </div>
        {subtitle && (
          <div
            style={{
              fontFamily: "var(--font-body)",
              fontSize: 13,
              color: "var(--fg2)",
              lineHeight: "18px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: 2,
            }}
          >
            {subtitle}
          </div>
        )}
      </div>
      {trailing !== undefined && (
        <div style={{ flex: "none", color: "var(--fg3)", display: "flex", alignItems: "center" }}>
          {trailing}
        </div>
      )}
    </div>
  );
}
